// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"400":"4604ca97","533":"6142a50a"}[chunkId] + ".chunk.js";
};